import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import Header from './components/feature/Header';
import ScrollProgressBar from './components/ui/ScrollProgressBar';
import PageTransition from './components/ui/PageTransition';
import CookieBanner from './components/ui/CookieBanner';
import { ThemeProvider } from './contexts/ThemeContext';
import { useEffect, Suspense } from 'react';

// Branded loading fallback to prevent whitescreens on lazy component load
function PageLoadingFallback() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center">
      <div className="relative w-12 h-12">
        <div className="w-12 h-12 rounded-full border-4 border-emerald-500/20 border-t-emerald-500 animate-spin"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-4 h-4 rounded-full bg-emerald-500 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
}

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col bg-white dark:bg-slate-900 transition-colors duration-300">
          <ScrollProgressBar 
            glowEffect={true} 
            particleTrail={true} 
            showPercentage={false}
          />
          <Header />
          <main className="flex-1 pt-16 lg:pt-18">
            <PageTransition>
              <Suspense fallback={<PageLoadingFallback />}>
                <AppRoutes />
              </Suspense>
            </PageTransition>
          </main>
          <CookieBanner />
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
